import React, { useState } from 'react'
import { Card, Button, Alert, Form } from 'react-bootstrap'
import { FaRegCopy } from 'react-icons/fa'

interface Props {
    username?: string
}

const ScriptCard: React.FC<Props> = ({ username }) => {
    const [copied, setCopied] = useState(false)

    const script = `<script src="https://cdn.nordpar.com/api/${username}/script.js"></script>`

    const handleCopy = () => {
        navigator.clipboard.writeText(script)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <Card className="shadow-sm mt-4">
            <Card.Body>
                <h4 className="mb-3">Script</h4>
                <p className="text-muted">
                    Place this before <code>&lt;/body&gt;</code>
                </p>

                <Form.Control
                    as="textarea"
                    rows={1}
                    readOnly
                    value={script}
                    className="bg-light monospace mb-3"
                />

                <Button variant="primary" onClick={handleCopy}>
                    <FaRegCopy className="me-2" />
                    Copy to clipboard
                </Button>

                {copied && (
                    <Alert variant="success" className="mt-2">
                        Copied to clipboard!
                    </Alert>
                )}
            </Card.Body>
        </Card>
    )
}

export default ScriptCard
